import { render } from "./SidebarCategoriesLabel.vue?vue&type=template&id=dd9becec&scoped=true"
import script from "./SidebarCategoriesLabel.vue?vue&type=script&lang=js"
export * from "./SidebarCategoriesLabel.vue?vue&type=script&lang=js"

import "./SidebarCategoriesLabel.vue?vue&type=style&index=0&id=dd9becec&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9becec"]])

export default __exports__